<template>
  <section>
    <template v-if="items.length === 0">
      <i>Zamówienie jest puste.</i>
    </template>
    <template v-for="item in items">
      <c-card class="mb-2" v-bind:key="item.pk">
        <c-card-header>
          <div class="d-flex align-items-center">
            <div class="font-xl">
              <strong>{{ item.name }}</strong>
            </div>
            <div class="ml-2">
              <c-badge color="primary" style="font-size: 115%;">
                {{ (item.price * item.pickCount).toFixed(2) }} zł
              </c-badge>
            </div>
          </div>
        </c-card-header>
        <c-card-body>
          Cena za 1 {{ item.unit }}: {{ item.price.toFixed(2) }} zł
          <br>
          Zamawiasz: {{ item.pickCount }} {{ item.unit }}
        </c-card-body>
      </c-card>
    </template>
    <c-card class="mb-2" v-if="items.length !== 0">
      <c-card-header>
        <div class="d-flex align-items-center">
          <div class="font-xl"><strong>Dostawa</strong></div>
          <div class="ml-2">
            <template v-if="$store.getters.totalPrice >= $store.state.minFreeDelivery">
              <c-badge color="success" style="font-size: 115%;">
                Za darmo!
              </c-badge>
            </template>
            <template v-else>
              <c-badge color="warning" style="font-size: 115%;">
                {{ $store.state.deliveryPrice }} zł
              </c-badge>
            </template>
          </div>
        </div>
      </c-card-header>
      <c-card-body>
        <strong>Zamów dzisiaj, aby otrzymać dostawę w dniu:
          {{ $store.state.nextDeliveryDate }}!</strong>
        <br>
        Dostawa dla zamówień powyżej {{ $store.state.minFreeDelivery }} zł: gratis
        <br>
        Dostawa dla zamówień poniżej {{ $store.state.minFreeDelivery }} zł: dodatkowo płatna {{ $store.state.deliveryPrice }} zł
      </c-card-body>
    </c-card>
    <c-card color="dark" class="text-white" v-if="$store.getters.totalPrice > 0">
      <c-card-body class="font-xl">
        <strong>
          Łączny koszt zamówienia z dostawą:
          {{ $store.getters.totalPricePlusDelivery.toFixed(2) }} zł
        </strong>
      </c-card-body>
    </c-card>
  </section>
</template>
<script>
export default {
  name: 'CartList',
  computed: {
    items() {
      return this.$store.getters.products
          .filter(product => product.pickCount !== 0)
          .map(product => ({
            name: product.fields.name,
            price: parseFloat(product.fields.unit_price),
            unit: product.fields.unit,
            pickCount: product.pickCount,
            pk: product.pk
          }))
    }
  }
}
</script>